import { BillingCycle } from '@api/api/subscription-schema';
import { Button } from '@design/components/button/Button';
import { VerifyEmailButton } from '@terminal/components/verify-email-button/VerifyEmailButton';
import { useQueryParams } from '@terminal/hooks/use-query-params/useQueryParams';
import { queryKeys } from '@terminal/routes/query-params';
import { useNavigateToCheckout } from '@terminal/views/settings/subscription/hooks/use-navigate-to-checkout/useNavigateToCheckout';
import {
  ChangingPlanTier,
  PlanCardType,
} from '@terminal/views/settings/subscription/plan-matrix/utils/plan-matrix.types';
import { useTranslation } from 'react-i18next';

import { PageVariants } from '../utils';

export const OnHoldActionButton = () => {
  const { t } = useTranslation('auth');
  const { params } = useQueryParams();
  const upgradeToPro = useNavigateToCheckout();
  const reason = params[queryKeys.reason];

  if (reason === PageVariants.Email) {
    return <VerifyEmailButton />;
  }

  if (reason === PageVariants.Payment) {
    return (
      <Button
        data-testid="verify-email-button"
        type="button"
        label={t('auth:onHold.enterPaymentMethod')}
        onClick={() =>
          upgradeToPro(
            {
              billingCycle: BillingCycle.year,
              tier: ChangingPlanTier.Initial,
              type: PlanCardType.Pro,
            },
            { replace: true }
          )
        }
      />
    );
  }

  return (
    <Button
      data-testid="resume-subscription-btn"
      label={t('auth:onHold.subscribe')}
      size="small"
      onClick={() => upgradeToPro({ tier: ChangingPlanTier.Upgrading })}
    />
  );
};
